import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Main from "../../../layout/main/Main";
import { Form } from "antd";
import { AntdButton, DistributorContainer, InnerForm } from "./styles";
import { Typo } from "../../../layout/theme";
import DistributorLabAlerts from "../../../common/distributors-lab-alerts/DistributorLabAlerts";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../utils/notificationToast";
import { update_client_distributors_alerts } from "../../../../api/endpoints/clients";

export default function LaboratoryAlerts({ clientId }) {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [form] = Form.useForm();
	const [submitting, setSubmitting] = useState(false);
	const [initialValues, setInitialValues] = useState(null);
	const [distributors, setDistributors] = useState(null);
	const [flag, setFlag] = useState(false);

	useEffect(() => {
		const fetch_alerts_by_clientId = async () => {
			// const dataPOS = await get_alerts_by_clientId(
			//   clientId
			// );
			// const formData = {
			//   distributors: dataPOS.distributors?.map((i) => ({
			//     key: i.id,
			//     id: i.id,
			//     code: i.code,
			//     name: i.name,
			//     photoUrl: i.photoUrl,
			//   })),
			// };
			// setInitialValues(formData);
		};

		if (clientId) fetch_alerts_by_clientId();
	}, []);

	const isValidEmail = (email) => {
		const emailRegex = /^[^@]+@[^@]+$/;
		return emailRegex.test(email);
	};

	const onFinish = async (values) => {
		try {
			const invalidDistributor = distributors?.some((d) => {
				return (
					(d.outOfStockItems || d.inexistentItems || d.errorItems) &&
					(!d.alertEmail || d.alertEmail === "" || !isValidEmail(d.alertEmail))
				);
			});

			if (invalidDistributor) {
				openNotificationWithIcon(
					TYPE.ERROR,
					"Error de validación",
					"Es obligatorio proporcionar un correo electrónico de alerta válido si se ha elegido fuera de stock, inexistentes o con error."
				);
				return;
			}

			setSubmitting(true);

			const postData = {
				id: clientId,
				distributors:
					distributors?.map((d) => ({
						id: d.id,
						outOfStockItems: d.outOfStockItems,
						inexistentItems: d.inexistentItems,
						errorItems: d.errorItems,
						alertEmail: d.alertEmail,
					})) || [],
			};

			await update_client_distributors_alerts(postData);

			openNotificationWithIcon(
				TYPE.SUCCESS,
				"Alertas editadas con exito",
				"Las alertas se editaron con exito"
			);
		} catch (error) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Error al editar alertas",
				"Un error ocurrio al intentar editar las alertas, contacte con soporte a soporte@checkpos.com."
			);
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Alertas</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				<Form
					form={form}
					name="basic"
					onFinish={onFinish}
					autoComplete="off"
					requiredMark={false}
					layout="vertical"
					initialValues={initialValues}
				>
					<InnerForm>
						<DistributorContainer>
							<Typo type="primary" level={4}>
								Alertas configuradas
							</Typo>
							<Form.Item>
								<DistributorLabAlerts
									onChange={setDistributors}
									initialValues={initialValues}
									clientId={clientId}
									flag={flag}
								/>
							</Form.Item>
						</DistributorContainer>
						<Form.Item>
							<AntdButton
								type="primary"
								htmlType="submit"
								loading={submitting}
								width={200}
							>
								Guardar
							</AntdButton>
						</Form.Item>
					</InnerForm>
				</Form>
			</Main.Body>
		</Main>
	);
}
